import React, { Component } from 'react'
import ToggleSection from 'components/shared/ToggleSection'
import * as OrgSelectors from 'app/modules/org/selectors'
import withNotifications from 'components/shared/notifications'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { partial, defaultTo } from 'ramda'
import { fetchOrgProperties } from 'app/modules/org/actions'
import { fetchIntegrationStates } from 'app/modules/integrations/actions'
import { toggleLinkedinIntegration } from 'app/modules/integrations/api'
import { LINKEDIN_HELPDOC_URL } from 'constants/HelpDocConstants'
import app from 'containers/app'

const TOGGLE_ERROR_MESSAGE = 'Oops, something went wrong. Please try again.'
const TOGGLE_DESCRIPTION = 'Enable this integration so your Drift team can access their LinkedIn Sales Navigator features from within Drift! Once enabled, your teammates will have the opportunity to connect their Sales Navigator accounts.'
const defaultToEmptyObject = defaultTo({})

class Linkedin extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isEnabled: props.isEnabled
    }
  }

  refreshOrgProperties = () => {
    const { notifications } = this.props
    const { isEnabled } = this.state
    notifications.success(`LinkedIn Sales Navigator has successfully been ${isEnabled ? 'connected' : 'disconnected'}!`)
    return this.props.actions.fetchOrgProperties()
  }

  toggleEnabled = (isEnabled) => {

    const onError = () => {
      this.props.notifications.error(TOGGLE_ERROR_MESSAGE)
      this.setState({ isEnabled: !isEnabled })
    }

    const onLocalStateSet = () => {
      toggleLinkedinIntegration(isEnabled)
        .catch(onError)
        .then(() => this.props.actions.fetchIntegrationStates())
        .then(this.refreshOrgProperties)
    }

    this.setState({ isEnabled }, onLocalStateSet)
  }

  render() {
    const { isEnabled } = this.state

    return (
      <div>
        <p className="linkedin-description">
          Enable the LinkedIn Sales Navigator Integration. &nbsp;
          <a href={LINKEDIN_HELPDOC_URL}>Learn more.</a>
        </p>
        <ToggleSection
          title="Add LinkedIn Sales Navigator to Drift"
          description={TOGGLE_DESCRIPTION}
          isActive={isEnabled}
          onToggled={partial(this.toggleEnabled, [!isEnabled])}
          className="linkedin-toggle-section"
        />
        <br/>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isEnabled: defaultToEmptyObject(OrgSelectors.properties(state)).isLinkedinEnabled
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ fetchOrgProperties, fetchIntegrationStates }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withNotifications(Linkedin)
)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Linkedin.js